module.exports = {"141182001":"文峰街道","141182002":"太和桥街道","141182100":"贾家庄镇","141182101":"杏花村镇","141182102":"冀村镇","141182103":"肖家庄镇","141182104":"演武镇","141182105":"三泉镇","141182106":"石庄镇","141182107":"杨家庄镇","141182108":"峪道河镇","141182200":"西河乡","141182201":"阳城乡","141182202":"栗家庄乡","141182400":"南薰街道","141182401":"辰北街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141182.json
// module id = 390
// module chunks = 0